export enum UnitSystem {
  EU = 'metric',
  US = 'imperial-us',
  UK = 'imperial-uk',
}
